import MobileNavBar from '@/components/MobileNavBar';
import { TrackList } from '@/components/TrackList';
import { useDimensions } from '@/hooks/useDimensions';
import { flattenNestedObject, shuffleArray } from '@/utils';
import { useEffect, useState } from 'react';

const Discover = () => {
  const { isMobileOrPad } = useDimensions();
  const cachedTracks = sessionStorage.getItem('jenMusicTracks');
  const [marketAudioListData, setMarketAudioListData] = useState();

  useEffect(() => {
    if (cachedTracks) {
      setMarketAudioListData(JSON.parse(cachedTracks));
    } else {
      fetch('https://app.jenmusic.ai/cdn/Hip-Hop%20for%20Homepage/list.json').then(async (res) => {
        const jsonData = await res.json();
        const formatTracks = (shuffleArray(flattenNestedObject(jsonData)) as any).map((trackItem: any) => {
          return {
            ...trackItem,
          };
        });
        setMarketAudioListData(formatTracks);
        sessionStorage.setItem('jenMusicTracks', JSON.stringify(formatTracks));
      });
    }
  }, []);

  return (
    <div>
      {isMobileOrPad && <MobileNavBar />}
      <div className="p-6 lg:px-12 lg:py-6 text-jen-content-primary text-[42px] lg:text-[24px] leading-none tracking-[-0.96px] ">
        Discover Music
      </div>
      <div className="px-6 lg:px-12">
        <TrackList itemsPerPage={20} trackListData={marketAudioListData} style={{ contentHeight: 'calc(100vh - 260px)' }} />
      </div>
    </div>
  );
};
export default Discover;
